module.exports = __webpack_public_path__ + "static/media/PadsSample.de0295b1.mp3";